import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useKubeData() {
    const { data: kubeOptions } = useQuery({
        queryKey: ['kube-options'],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.kube.options'));
            return data;
        },
        placeholderData: [],
    });

    return {
        kubeOptions,
    };
}
